<template>
  <div class="pkg-content" v-loading="dataListLoading">
    <el-row>
      <el-col :span="24" align="right">
        <el-button type="primary" @click="handleBack"
          >{{ $t("返回") }}
        </el-button>
      </el-col>
    </el-row>
    <div class="divider" />

    <div>
      <el-form
        label-position="top"
        :inline="true"
        :model="dataForm"
        ref="dataForm"
      >
        <div class="opten-title">
          <em class="el-icon-caret-right"></em>平账信息
        </div>
        <el-row class="row-mar-l">
          <el-col :span="6">
            <!-- 平账编号 -->
            <el-form-item label="平账编号" prop="balanceAccountNo">
              <el-input
                v-model="dataForm.balanceAccountNo"
                placeholder="自动生成"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 平账类别 -->
            <el-form-item label="平账类别">
              <span slot="label">平账类别
                <el-tooltip placement="top-start" effect="dark">
                  <div slot="content">
                    <div>价格变更：在手工平账管理中创建的平账单</div>
                    <div>培训状态修改：在修改已有平账记录的培训记录状态时创建的平帐单</div>
                  </div>
                  <img
                          style="width: 14px; height: 14px"
                          src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                          alt=""
                  />
                </el-tooltip>
              </span>
              <el-select
                v-model="dataForm.balanceAccountType"
                clearable
                placeholder="请选择"
                :disabled="true"
              >
                <el-option
                  v-for="item in balanceAccountTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <!-- 平账标题 -->
            <el-form-item label="平账标题" prop="balanceAccountTitle">
              <el-input
                v-model="dataForm.balanceAccountTitle"
                placeholder="请输入平账标题"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 单条培训记录需平账金额 -->
            <el-form-item
              prop="amountType"
            >
            <span slot="label">单条培训记录平账金额
                <el-tooltip placement="top-start" effect="dark">
                  <div slot="content">
                    <p>平账金额表示单条培训记录平账的金额</p>
                    <p>补缴：表示填入的金额需要结算时经销商补缴</p>
                    <p>退款：表示填入的金额将退回给结算时经销商</p>
                  </div>
                  <img
                          style="width: 14px; height: 14px"
                          src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                          alt=""
                  />
                </el-tooltip>
              </span>
              <el-select
                v-model="dataForm.amountType"
                clearable
                style="width: 40% !important"
                placeholder="请选择"
                :disabled="true"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <currency-input
                v-model="dataForm.singleAmount"
                :min="0"
                :max="99999999.99"
                :precision="2"
                style="width: 59% !important"
                :disabled="true"
              ></currency-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">

          <el-col :span="12">
            <!--  平账凭证 -->
            <el-form-item label="平账凭证" prop="fileList" style="width: 90% !important">
              <el-upload
                disabled
                ref="upload"
                :show-file-list="true"
                :action="uploadUrl"
                :on-preview="handlePreview"
                :file-list="dataForm.fileList"
                :auto-upload="true"
              >
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <el-col :span="24" style="text-align: center">
            <el-form-item
              label="平账说明"
              prop="balanceDes"
              style="width: 95% !important"
            >
              <el-input
                v-model="dataForm.balanceDes"
                type="textarea"
                rows="5"
                maxlength="1000"
                show-word-limit
                :disabled="true"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="opten-title" style="margin-top: 30px">
        <em class="el-icon-caret-right"></em>平账培训记录
      </div>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-table
            ref="multipleTable"
            :data="tablePagingData"
            border
            :row-style="{ height: 48 + 'px' }"
            :cell-style="{ padding: 0 + 'px' }"
            class="table_item"
          >
            <!-- 培训记录编号 -->
            <el-table-column
              prop="trainingKey"
              label="培训记录编号"
              header-align="center"
              align="center"
              min-width="280px"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 用户ID -->
            <el-table-column
              prop="userCode"
              label="用户ID"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 用户姓名 -->
            <el-table-column
              prop="userNameCn"
              label="用户姓名"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 课程代码 -->
            <el-table-column
              prop="courseCode"
              label="课程代码"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 课程名称 -->
            <el-table-column
              prop="courseName"
              label="课程名称"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 排期编号 -->
            <el-table-column
              prop="offeringNo"
              label="排期编号"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 排期开始时间 -->
            <el-table-column
              prop="offeringStartDate"
              label="排期开始时间"
              header-align="center"
              align="center"
              min-width="140"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 排期结束时间 -->
            <el-table-column
              prop="offeringEndDate"
              label="排期结束时间"
              header-align="center"
              align="center"
              min-width="140"
              :show-overflow-tooltip="true"
            ></el-table-column>
             <el-table-column
                  prop="offeringPrice"
                  header-align="center"
                  align="right"
                  show-overflow-tooltip
                  label="报名时排期价格（元）"
                  min-width="165px"
                >
              <template slot-scope="scope">
                {{ scope.row.offeringPrice | formatMoney }}
              </template>
              </el-table-column>
            <!-- 合计结算费用（元） -->
            <el-table-column
              label="合计结算费用（元）"
              header-align="center"
              align="right"
              min-width="160"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  width="400px"
                  trigger="click">
                  <el-row>
                    <el-col :span="24" style="height: 44px; margin: auto; text-align: center; font-weight: 700; font-size: 14px; background-color: #F2F2F2;">
                      <p>结算费用明细</p>
                    </el-col>
                  </el-row>
                  <el-table :data="gridData" v-loading="gridLoading"   style="width: 460" :cell-style="cellStyle">
                    <el-table-column header-align="center" width="220" label="摘要" align="center" show-overflow-tooltip prop="detail"></el-table-column>
                    <el-table-column header-align="center" width="105" label="结算费用" align="right" prop="billingPrice">
                      <template slot-scope="scope">
                        {{scope.row.billingPrice | formatMoney}}
                      </template>
                    </el-table-column>
                    <el-table-column header-align="center" min-width="135" label="平账编号" align="center" show-overflow-tooltip prop="balanceAccountNo"></el-table-column>
                  </el-table>
                  <!-- <el-link type="primary" :underline="false" slot="reference">{{scope.row.settlementFeesTotal}}</el-link> -->
                  <span slot="reference" @click="loadData(scope.row)" style="color: #409eff; cursor: pointer;">{{scope.row.countPrice | formatMoney}}</span>
                </el-popover>
              </template>
            </el-table-column>
            <!-- 报名时经销商 -->
            <el-table-column
              prop="orgNameCn"
              label="报名时经销商"
              header-align="center"
              align="center"
              min-width="160"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 结算时经销商 -->
            <el-table-column
              prop="orgParentNameCn"
              label="结算时经销商"
              header-align="center"
              align="center"
              min-width="160"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 培训记录状态 -->
            <el-table-column
              prop="trainingStatus"
              label="培训记录状态"
              header-align="center"
              align="center"
              min-width="160"
              :show-overflow-tooltip="true"
              :formatter="format"
            ></el-table-column>
            <!-- 发票号 -->
            <el-table-column
              prop="invoiceNumber"
              label="发票号"
              header-align="center"
              align="center"
              min-width="180"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 结算状态 -->
            <el-table-column
              prop="settlementStatus"
              label="结算状态"
              header-align="center"
              align="center"
              min-width="180"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </el-table>
          <el-pagination
            :current-page="tablePaging.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="tablePaging.pageSize"
            :total="dataForm.trainingRecordList.length"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle"
          >
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

//import mixinViewModule from "@/mixins/view-module";
import currencyInput from './components/currency-input';
export default {
  name: 'handworkBalanceAccountView',
  components: {
       currencyInput,
     },
  //mixins: [mixinViewModule],
  data() {
    let _this = this;
    return {
      uploadUrl: "/learning/account/picupload",
      mixinViewModuleOptions: {
        getBillingDetailsUrl: '/learning/account/getBillingDetails',
        getDetail: '/learning/account/getHandDetail',
      },
      dataListLoading: false,
      statusList: [
        { label: "补缴", value: "10" },
        { label: "退款", value: "20" }
      ],
      balanceAccountTypeList: [
        { label: "价格变更", value: "10" },
        { label: "培训状态修改", value: "20" }
      ],
      dataForm: {
       id: "",
        sourceId: "",
        balanceAccountNo: "",
        balanceAccountTitle: "",
        amountType: "",
        balanceAccountType: "",
        singleAmount: "",
        balanceDes: "",
        fileList: [],
        trainingRecordList: [],
      },
      tablePaging: {
        pageNum: 1,
        pageSize: 10,
        data: [],
      },
      gridLoading: false,
      gridData: []
    };
  },
  // 计算属性
  computed: {
    // 表格分页
    tablePagingData() {
      let start = (this.tablePaging.pageNum - 1) * this.tablePaging.pageSize;
      let end = this.tablePaging.pageNum * this.tablePaging.pageSize;
      return this.dataForm.trainingRecordList.slice(start, end);
    },
  },
  watch: {},
  activated: function(){
    if (this.$route.query) {
      this.dataForm.id = this.$route.query.id;
      this.dataForm = this.$route.query.data;
      this.dataForm.trainingRecordList = this.$route.query.data.trainingRecordList;
      this.dataForm.fileList = this.$route.query.data.fileList
    }
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    if (this.$route.query) {
      this.dataForm.id = this.$route.query.id;
      this.dataForm = this.$route.query.data;
      this.dataForm.fileList = this.$route.query.data.fileList
    }
  },
  destroyed() {
    console.log('destroyed')
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    console.log("mounted:")
    this.getDetail()
  },
  filters: {
    rounding (value) {
     if (value == null) {
        return null
      } else {
        return value.toFixed(2)
      }
    },
    formatMoney(num) {
      if (!num && num !== 0 && num !== '0') {
        return ''
      }
      num = num.toString().replace(/\$|\,/g, '')
      if (isNaN(num)) {
        num = '0'
      }
      let sign = num == (num = Math.abs(num))
      num = Math.floor(num * 100 + 0.50000000001)
      let cents = num % 100
      num = Math.floor(num / 100).toString()
      if (cents < 10) {
        cents = '0' + cents
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
      }
      return (sign ? '' : '-') + num + '.' + cents
    }
  },
  methods: {
    formatMoney(num) {
      if (!num && num !== 0 && num !== '0') {
        return ''
      }
      num = num.toString().replace(/\$|\,/g, '')
      if (isNaN(num)) {
        num = '0'
      }
      let sign = num == (num = Math.abs(num))
      num = Math.floor(num * 100 + 0.50000000001)
      let cents = num % 100
      num = Math.floor(num / 100).toString()
      if (cents < 10) {
        cents = '0' + cents
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
      }
      return (sign ? '' : '-') + num + '.' + cents
    },
    handleBack() {
      this.$router.push({
        path: "/manage/charge-handworkBalanceAccount-index",
        params: {},
      });
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.tablePaging.pageNum = 1;
      this.tablePaging.pageSize = val;
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.tablePaging.pageNum = val;
    },
    loadData(row) {
        // 清空gridData数据
      // 设置加载状态
      console.log(row)
      this.$request.post(
        this.mixinViewModuleOptions.getBillingDetailsUrl,
        {
          trainingKey: row.trainingKey
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        this.gridData = data.data
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
        // 延迟加载
        // this.$nextTick(() => {
        //   this.querSelect()
        // })
      }).catch(() => {
        this.dataListLoading = false
      })
      this.gridLoading = true
      // 调用后端获取数据赋值给gridData
      //this.gridData = []
      // 取消加载状态
      this.gridLoading = false

    },
    getDetail() {
      this.dataListLoading = true
      this.$request.get(
              this.mixinViewModuleOptions.getDetail,
              {
                'balanceAccountNo': this.dataForm.balanceAccountNo
              }
      ).then((res, total, code, data) => {
        this.dataForm.trainingRecordList = data.data
        this.dataListLoading = false
      }).catch(() => {
        this.dataListLoading = false
      })


    },
    cellStyle({row, rowIndex}) {
      return 'border-right: initial !important; padding: 4px 0;'
    },
    format(row,column){
     if(row.trainingStatus === "10"){
        return "待审批"
      } else if(row.trainingStatus === "20"){
        return "已报名"
      } else if(row.trainingStatus === "30"){
        return "已拒绝"
      } else if(row.trainingStatus === "40"){
        return "已撤销"
      } else if(row.trainingStatus === "50"){
        return "等待中"
      } else if(row.trainingStatus === "60"){
        return "缺勤"
      } else if(row.trainingStatus === "70"){
        return "已完成"
      } else if(row.trainingStatus === "80"){
        return "未通过"
      } else if(row.trainingStatus === "90"){
        return "进行中"
      }
    },
     handlePreview(file) {
      console.log(file)
      if (this.dataForm.fileList === '' || this.dataForm.fileList === null || this.dataForm.fileList === undefined) {
        this.$message({
          message: '请先上传文件',
          type: 'error',
          duration: 1500,
        })
      } else {
        this.$message({
          message: this.$t('user.authApplyDownloadFileMessage'),
          type: 'info',
          duration: 1000,
        })
        this.$request.downloadBigFile('/learning/account/picDownload',
        // this.$request.download('/sys/commAdminFileManagement/downloadFile',
          file.name,
          {
            url: file.url,
            name: file.name
          },
          null,
          false
        )
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" scoped lang="scss">
@import "../../../css/pkg-styles.css";
.divider {
  display: block;
  height: 2px;
  width: 100%;
  margin: 24px 0;
  background-color: #a2a2a2;
  position: relative;
}
.fl-input.is-disabled  .el-input__inner {
  color: blue !important;
  text-decoration: underline;
  cursor: pointer;
}
.button_item, .table_item {
  text-align: left;
  margin-bottom: 7px !important;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
  width: 95% !important;
}
.el-col-12 {
  text-align: center;
}
 .el-select.el-select--default  .el-input.el-input--default.el-input--suffix input {
   height: 34px;
   margin-right: 2px;
 }
 .el-input.el-input--default {
   float: right;
 }
  .el-upload-list {
   float: left;
 }
</style>
